import { Col } from "@commonlibs";
import styled, { css } from "styled-components";
import { ThemeSpacingValues } from "ui/config/theme/spacing/spacing.types.d";
import { FormProps } from "./Form";

export const FORM_ROW_GAP = "7";

export const FormWrapper = styled(Col)<Partial<Pick<FormProps, "gap">>>(
    ({ theme, gap = FORM_ROW_GAP }) => css`
        row-gap: ${theme.spacing[gap as keyof ThemeSpacingValues]};
    `,
);
